import * as React from "react";
import { RichTextBannerBox } from "./style";
export interface TypographyProps {
	positionId: string;
	content: string;
	bgColor?: string;
}
export default class MTypography extends React.PureComponent<TypographyProps, {}> {
	render() {
		const { content, bgColor = "", positionId } = this.props;

		return (
			<section data-id={positionId} id={positionId}>
				<RichTextBannerBox color={bgColor}>
					<div dangerouslySetInnerHTML={{ __html: content }} />
				</RichTextBannerBox>
			</section>
		);
	}
}
